import { defineStore } from "pinia";

export const useMedicalCompanionStore = defineStore('medicalCompanion', {
    state: () => ({
        medicalCompanion: {},
        medicalCompanions: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setMedicalCompanion(medicalCompanion) {
            this.medicalCompanion = medicalCompanion
        },
        setMedicalCompanions(medicalCompanions) {
            this.medicalCompanions = medicalCompanions
        },
        addMedicalCompanion(medicalCompanion) {
            this.medicalCompanions.unshift(medicalCompanion)
        },
        updateMedicalCompanion(medicalCompanion) {
            let index = this.medicalCompanions.findIndex(cl => cl.id === medicalCompanion.id)
            this.medicalCompanions.splice(index, 1, medicalCompanion)
        },
        deleteMedicalCompanion(medicalCompanion) {
            let index = this.medicalCompanions.findIndex(cl => cl.id === medicalCompanion.id)
            this.medicalCompanions.splice(index, 1)
        },
    },
});